/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbCloudSchemaRequest {
    getFixupPrototypeFunction() { return ServiceNowCmdbCloudSchemaRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbCloudSchemaRequest>): ServiceNowCmdbCloudSchemaRequest {
        let obj = Object.assign(new ServiceNowCmdbCloudSchemaRequest(), model);
        ServiceNowCmdbCloudSchemaRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbCloudSchemaRequest>): ServiceNowCmdbCloudSchemaRequest {
        if (!model) return null;
        return ServiceNowCmdbCloudSchemaRequest.newInstance(<ServiceNowCmdbCloudSchemaRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbCloudSchemaRequest) {
        if (!obj) return;

        models.ServiceNowCmdbCloudSchemaRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbCloudSchemaRequest): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbCloudSchemaRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud Provider to select
     */
    service_name: models.CloudServiceName;

    /**
     * flag to return inventory hierarchy for monitoring support resources
     */
    monitoring_support_schema: boolean;

}
